export function normalizeSegment(segment = '') {
  return decodeURIComponent(segment)
    .trim()
    .toLowerCase()
    .replaceAll('æ', 'ae')
    .replaceAll('ø', 'oe')
    .replaceAll('å', 'aa')
    .replace(/[^a-z0-9]+/g, '-')
    .replace(/-+/g, '-')
    .replace(/^-|-$/g, '')
}

export function normalizePath(pathname = '/') {
  if (!pathname || pathname === '/') {
    return '/'
  }

  const path = decodeURIComponent(pathname).replace(/\/+/g, '/')
  const segments = path
    .split('/')
    .filter(Boolean)
    .map((segment) => normalizeSegment(segment))

  return `/${segments.join('/')}`.replace(/\/$/, '') || '/'
}

export function slugifyValue(value = '') {
  return normalizeSegment(value)
}

export function stripHtml(html = '') {
  return html.replace(/<[^>]*>/g, ' ').replace(/\s+/g, ' ').trim()
}

export function truncateText(value = '', length = 150) {
  if (value.length <= length) return value
  return `${value.slice(0, Math.max(0, length - 1)).trimEnd()}…`
}
